import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, IconButton } from "@material-ui/core";
import RotateRightIcon from "@material-ui/icons/RotateRight";

import API from "../../API";
import { responsiveSize } from "../../services/misc.service";

const sizeOne = 3;
const sizeTwo = 5;

const ReservationPhoto = () => {
  const [imageUrl, setImageUrl] = useState();
  const [photoRotation, setPhotoRotation] = useState(90);
  const [photoSize, setPhotoSize] = useState(responsiveSize(sizeOne));
  const [photoContainerSize, setPhotoContainerSize] = useState(responsiveSize(sizeTwo));
  const { reservationId } = useParams();

  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        const parking = await API.reservations.getParkingPhoto(reservationId);
        if (parking?.photo) setImageUrl(parking.photo);
      } catch(err) {
        console.error(err);
      }
    };
    fetchPhoto();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setPhotoSize(responsiveSize(sizeOne));
      setPhotoContainerSize(responsiveSize(sizeTwo));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRotate = () => {
    setPhotoRotation(photoRotation < 270 ? photoRotation + 90 : 0);
  };

  const styles = {
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#1d212d",
      border: "1px solid #1d212d",
      position: "relative",
      height: photoContainerSize,
    },
    image: {
      height: photoSize,
      transform: `rotate(${photoRotation}deg)`,
    },
    rotateIcon: {
      position: "absolute",
      top: "5px",
      left: "5px",
    },
  };

  return (
    <Grid style={styles.imageContainer}>
      {imageUrl
        ? (
          <div>
            <img
              src={imageUrl}
              alt="A parked scooter"
              style={styles.image}
            />
            <IconButton onClick={() => handleRotate()} style={styles.rotateIcon}>
              <RotateRightIcon />
            </IconButton>
          </div>
        )
        : "No image"
    }
    </Grid>
  );
};

export default ReservationPhoto;
